var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11319_12372)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11319_12372)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11319_12372",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H20V20H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11319_12372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 15H17.0703C18.3648 15 19.4141 13.9508 19.4141 12.6562V7.96875C19.4141 6.67422 18.3648 5.625 17.0703 5.625H2.92969C1.63516 5.625 0.585938 6.67422 0.585938 7.96875V12.6562C0.585938 13.9508 1.63516 15 2.92969 15H4.0625",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 11.875H3.125",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23437 19.4141H14.7656C15.4128 19.4141 15.9375 18.8894 15.9375 18.2422V11.875H4.0625V18.2422C4.0625 18.8894 4.58719 19.4141 5.23437 19.4141Z",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 14.375H8.4375",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 16.875H8.4375",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.125H3.125",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40625 0.585938H13.5937C14.8882 0.585938 15.9375 1.63527 15.9375 2.92969V5.625H4.0625V2.92969C4.0625 1.63527 5.11184 0.585938 6.40625 0.585938Z",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11319_12372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11319_12372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrint);
export default __webpack_public_path__ + "static/media/ic-print.2962ae139d6c8f52a4868e0f111ffe31.svg";
export { ForwardRef as ReactComponent };